import { createStore } from "vuex";
import axios from "axios";
import { getAPI } from "@/axios-api";

export default createStore({
  state: {
    tasks: [],
  },
  getters: {
    allTasks: (state) => state.tasks,
  },
  mutations: {
    settasks: (state, tasks) => (state.tasks = tasks),
    newTodd: (state, todo) => state.tasks.unshift(todo),
    removeTodo: (state, id) => {
      state.tasks = state.tasks.filter((tasks) => tasks.id !== id);
    },
    completeTodo: (state, index) => {
      state.tasks[index].completed = !state.tasks[index].completed;
    },
  },
  actions: {
    async listTasks({ commit }) {
      const response = await getAPI.get("task_list");
      commit("settasks", response.data);
    
    },

    async addTask({ commit }, description) {
      const response = await getAPI.post("task_create/", {
        description: description,
        completed: false,
      });
      commit("newTodo", response.data);
    },

    async deleteTask({ commit }, id) {
      await getAPI.delete(`task_delete/${id}/`);
      commit("removeTodo", id);
    },

    async completeTask({ commit }, index) {
      var taskId = this.state.tasks[index].id;
      await getAPI.patch(`task_complete/${taskId}/`, {
        description: this.state.tasks[index].description,
        completed: !this.state.tasks[index].completed,
      });
      commit("completeTodo", index);
    },
  },
  modules: {},
});
